// extracted by mini-css-extract-plugin
export default {"banner":"_404_banner__iS217","bannerContainer":"_404_bannerContainer__YmOED"};